import { FileTextIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from "@/components/ui/collapsible";

export function ThreadContext({ context }: { context: string }) {
	return (
		<Collapsible className="rounded-lg border bg-muted/20">
			<CollapsibleTrigger className="flex w-full cursor-pointer items-center gap-2 px-4 py-3 text-sm font-medium">
				<FileTextIcon className="size-4 text-muted-foreground" />
				Thread Context
			</CollapsibleTrigger>
			<CollapsibleContent>
				<Card size="sm" className="mx-3 mb-3 border">
					<CardContent>
						<pre className="whitespace-pre-wrap text-xs text-muted-foreground">
							{context}
						</pre>
					</CardContent>
				</Card>
			</CollapsibleContent>
		</Collapsible>
	);
}
